import footerStyle from './footer.module.css';
import logoIcon from '../assets/logo-lungo.svg';
import { Link } from 'react-router-dom';
import { HOMEPAGE_URL } from '../constants/SocialTypes';

function Footer() {
    return (
        <footer className={footerStyle.bgDarkBlue + ' footer'}>
            <div className='mw-1500 d-flex py-5 px-5 flex-wrap'>
                <div className='col-12 col-md-6 mb-3 mb-lg-0'>
                    <ul className='p-0'>
                        <li>
                            <Link to={HOMEPAGE_URL}>
                                <img src={logoIcon} className='img-fluid p-3 p-md-0' style={{ maxWidth: '300px' }} />
                            </Link>
                        </li>
                        <li>&copy; Fiducia Accounting & Business Services P.S.<br />11907 SE 186th St, Renton, WA 98058</li>
                        <li>
                            <Link to={'https://fiduciaps.com/privacy-policy/'} className='text-decoration-none' target='_blank'>
                                Privacy policy
                            </Link>
                        </li>
                        <li>
                            <Link to={'https://www.adhocweb.it/'} className='text-decoration-none' target='_blank'>
                                Made with 💚 by AD HOC
                            </Link>
                        </li>
                    </ul>
                </div>
                <div className='col-12 col-md-6 mb-3 mb-lg-0'>
                    <h5 className='h2 fw-normal mb-4'>Accounting services of a high quality</h5>
                    <div className="row">
                        <div className="col-12 col-md-6">
                            <p className='fw-medium'>Menu</p>
                            <ul className='p-0'>
                                <li className='line-hover'>
                                    <Link to={'https://fiduciaps.com/#about'} className='text-decoration-none' target='_blank'>
                                        <span>About</span>
                                    </Link>
                                </li>
                                <li className='line-hover'>
                                    <Link to={'https://fiduciaps.com/#missionevalues'} className='text-decoration-none' target='_blank'>
                                        <span>Mission &amp; Values</span>
                                    </Link>
                                </li>
                                <li className='line-hover'>
                                    <Link to={'https://fiduciaps.com/#services'} className='text-decoration-none' target='_blank'>
                                        <span>Services</span>
                                    </Link>
                                </li>
                                <li className='line-hover'>
                                    <Link to={'https://fiduciaps.com/contact/'} className='text-decoration-none' target='_blank'>
                                        <span>Contact</span>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <div className="col-12 col-md-6">
                            <p className='fw-medium'>Say Hello</p>
                            <ul className='p-0'>
                                <li>
                                    <Link to={'mailto:info@fiduciaps.com'} className='text-decoration-none' target='_blank'>
                                        info@fiduciaps.com
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer >
    );
}

export default Footer;